import { createGlobalStyle } from 'styled-components';

export const GlobalStyle = createGlobalStyle`
  body {
    background: #F7FAFF;
    margin: 0;
  }
  h1,h2,h3,h4,h5,h6 {
    margin: 0;
    color: ${(props) => props.theme.colors.text};
  }
  p {
    margin: 0;
  }
  a {
    text-decoration: none;
  }
  #layers {
    z-index: 1001;
  }
`;
